export const salesPerson = "user/find-by-role";
export const customer = "user/find-by-role";
export const addSalesPerson = "/user/create";
export const updateSalesPerson = "/user";
export const deleteSalesPerson = "/user";
export const assignCustomerToSalesPerson =
  "/user/{id}/assign-customers";
export const salesPersonDetails = "/user/find-one";
export const deleteAssignCustomer =
  "/user/{userId}/assigned-customers";
